import { localStorageSet } from '@Infra/LocalStorage';
import { LOCAL_STORAGE_KEYS } from '@Infra/LocalStorage/keys';

/**
 * Synchronous, not a thunk: this is a purely local device preference (no server round-trip, no
 * store slice to keep it in), called by `fetchRecordingPolicy` right after a successful read of the
 * policy. It is what lets `readDeviceRetention` answer synchronously, offline, on the very first
 * render of the next session — before any network call has had a chance to complete.
 */
const recordDeviceRetention = (deviceRetentionMs: number): void => {
	localStorageSet(LOCAL_STORAGE_KEYS.DEVICE_RETENTION_MS, String(deviceRetentionMs));
};

export default recordDeviceRetention;
